import React from 'react';
import './BentoLoader.css';

const toLength = (value) => (typeof value === 'number' ? `${value}px` : value);

const toDuration = (value) => (typeof value === 'number' ? `${value}ms` : value);

/**
 * BentoLoader
 *
 * Three-tile animated loading indicator.
 *
 * @example
 * <BentoLoader />
 *
 * @example
 * <BentoLoader size={48} duration="2s" />
 *
 * @example
 * <BentoLoader label={null} />
 */
export default function BentoLoader({
    size = 32,
    duration = '1.5s',
    label = 'Loading',
    className,
}) {
    const accessible = label !== null;

    const style = {
        '--bento-loader-size': toLength(size),
        '--bento-loader-duration': toDuration(duration),
    };

    return (
        <span
            className={['bento-loader', className].filter(Boolean).join(' ')}
            style={style}
            role={accessible ? 'status' : undefined}
            aria-live={accessible ? 'polite' : undefined}
            aria-label={accessible ? label : undefined}
            aria-hidden={!accessible}
        >
            <span className="bento-loader__tile" aria-hidden="true" />
            <span className="bento-loader__tile" aria-hidden="true" />
            <span className="bento-loader__tile" aria-hidden="true" />
        </span>
    );
}
